export const SET_EDITING_TEXT_NUMBER = 'SET_EDITING_TEXT_NUMBER'
